import './update-power.scss';
import React from 'react';
import { connect } from 'react-redux';
import { provideHooks } from 'redial';
import { getOrder } from '../../../actionCreators/order';
import { showGlobalHeaderFooter } from '../../../actionCreators/header';
import { getQueryParam } from '../../../utils/helper';
import UpdatePower from '../../components/UpdatePower/UpdatePower';
import CheckoutHeader from '../../components/Checkout/CheckoutHeader/CheckoutHeader';

@provideHooks({
    fetch: ({ location, store: { dispatch } }) => {
        dispatch(showGlobalHeaderFooter({ header: false, footer: false }));
        const query = location.search.substr(1);
        const orderId = getQueryParam(query, 'orderId');
        const email = getQueryParam(query, 'email');
        dispatch(getOrder({ orderId, email }));
    }
})

class UpdatePowerContainer extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const { order } = this.props;
        const { billingAddress, items, id } = order || {};
        const { firstName, lastName } = billingAddress || {};
        const userName = `${firstName} ${lastName}`;
        const appLogo = 'https://static.lenskart.com/media/desktop/img/checkout_Lenskart_logo_2x.png';
        return (
            <div>
                <CheckoutHeader cartHeader={appLogo} />
                <React.Fragment>
                    <div className="update-power-container container clear-both">
                        <h3 className="margin-b0 margin-t0" style={{ color: '#cc0000', fontFamily: 'Rajdhani-Medium' }}>
                            <span className="inline-block padding-r10">Order #{id}</span>
                            {billingAddress && <span className="inline-block capitalize">Customer Name: {userName}</span>}
                        </h3>
                        <hr className="margin-t10 margin-b10" />
                        <div className="padding-t15 padding-b15">
                            {items && items.map(item => <UpdatePower key={item.id} item={item} userName={userName} email={order.customerEmail} orderId={order.id} />)}
                        </div>
                    </div>
                </React.Fragment>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const order = state.order.orderDetails ? state.order.orderDetails.result : null;
    return {
        order
    };
}

export default connect(mapStateToProps)(UpdatePowerContainer);
